export const brandData = [
  {
    link:"/event",
    imgSrc:"./images/main/brand/brand01.jpg",
    title:"give all things cozy",
    subTxt:"따뜻한 소재로 겨울 내내 포근한 척 스니커즈"
  },
  {
    link:"/event",
    imgSrc:"./images/main/brand/brand02.jpg",
    title:"level up in leather",
    subTxt:"견고한 레더로 럭셔리하게 재해석한 척 스니커즈"
  },
  {
    link:"/event",
    imgSrc:"./images/main/brand/brand03.jpg",
    title:"converse for kids",
    subTxt:"포근하고 따뜻한 플리스 이지-온 컨버스 키즈"
  },
  {
    link:"/event",
    imgSrc:"./images/main/brand/brand04.jpg",
    title:"converse color",
    subTxt:"가을 룩에 어울리는 나만의 컬러를 찾아보세요"
  },
];